import React, { useState } from "react";
import OTPInput from "react-otp-input";
import { Button, ModalBody, ModalHeader } from "reactstrap";
import { verifyOtp } from "services/merchantAuthServices";
import { compose } from "redux";
import { connect } from "react-redux";
import navigationAction from "redux/navigation/actions";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

let { success, error } = navigationAction;

function OTPModal(props) {
  const { closeModal } = props;
  const [otp, setOtp] = useState("");

  const VerifyOTP = async () => {
    let payload = {
      email: props.isResendRequest ? props?.email : props?.merchant?.email,
      otp
    };
    await verifyOtp(payload).then(response => {
      if (response.success) {
        success(response.message);
        props.history.push("/login");
        closeModal();
        if (props?.isResendRequest) {
          props?.setWarning();
        }
      } else {
        setOtp("");
        error(response.message);
      }
    });
  };
  return (
    <div>
      <ModalHeader>OTP Authentication</ModalHeader>
      <ModalBody className="my-4">
        <span
          className="d-block text-center"
          style={{ margin: "10px", marginLeft: "25px" }}
        >
          An otp has been sent to your registered email id
        </span>
        <div className="form-group">
          <span
            className="d-block text-center"
            style={{ margin: "10px", marginLeft: "25px" }}
          >
            Enter your otp
          </span>
          <OTPInput
            inputStyle={{
              height: "50px",
              width: "50px",
              margin: "auto",
              border: "1px solid #ccc",
              borderRadius: "5px"
            }}
            containerStyle={{ marginBottom: "30px", marginTop: "20px" }}
            value={otp}
            onChange={setOtp}
            numInputs={4}
            renderSeparator={<span>-</span>}
            renderInput={props => <input {...props} />}
          />
        </div>
        <div className="row justify-content-center mt-5">
          <div className="col-auto">
            <Button
              onClick={e => {
                VerifyOTP();
              }}
              type="submit"
              className="btn btn-info w-100 btn-bordered"
            >
              Verify
            </Button>
          </div>
          <div className="col-auto">
            <Button
              onClick={() => {
                closeModal();
                props.history.push("/login");
              }}
              className="btn btn-dark w-100 btn-bordered"
            >
              Cancel
            </Button>
          </div>
        </div>
      </ModalBody>
    </div>
  );
}
const mapStateToProps = state => {
  console.log(state, "state check");
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
    user: state.auth.user
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, { success, error })
)(OTPModal);
